import { useQuery, useMutation } from '@tanstack/react-query';
import { UpdateInspectionStatusAccessRule } from '@/types';
import { QUERY_KEYS } from '../../queryKeys';
import { inspectionStatus } from '../InspectionStatus';

type OptionsType = {
  enabled: boolean;
};

export const useInspectionStatusAccessRules = (options?: OptionsType) =>
  useQuery({
    queryKey: [QUERY_KEYS.inspectionStatusAccessRules],
    queryFn: async () => (await inspectionStatus.getAccessRules()).data,
    enabled: options?.enabled,
  });

export const useInspectionStatuses = (options?: OptionsType) =>
  useQuery({
    queryKey: [QUERY_KEYS.inspectionStatuses],
    queryFn: async () => (await inspectionStatus.getStatuses()).data,
    enabled: options?.enabled,
  });

export const useCreateInspectionStatusAccessRule = () =>
  useMutation({ mutationFn: inspectionStatus.createAccessRule });

export const useUpdateInspectionStatusAccessRule = () =>
  useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: number;
      data: UpdateInspectionStatusAccessRule;
    }) => inspectionStatus.updateAccessRule(id, data),
  });

export const useDeleteInspectionStatusAccessRule = () =>
  useMutation({ mutationFn: inspectionStatus.removeAccessRule });
